import { observable, action } from 'mobx'
import BaseStore from '@store/table'
import { now, getMomentTime } from '@hlj/hlj-utils'
import Api from '@api/live'

class Store extends BaseStore {
  @observable date = [now(-30), now()]

  $listApi = Api.rechargeList
  $getParams = () => {
    const { ...rest } = this.$params

    return {
      begin_date: getMomentTime(this.date, 0),
      end_date: getMomentTime(this.date, 1),
      ...rest
    }
  }

  @action
  changeParams = e => {
    this.date = e
    this.$getList(1)
  }
}
export default new Store()
